import { useSyncExternalStore } from 'react';

const MOBILE_BREAKPOINT = 640;
// matchMedia evaluates the viewport without the forced layout that reading innerWidth costs at mount.
// Negating Tailwind's sm query keeps fractional widths between 639 and 640px in sync with the CSS.
const MOBILE_MEDIA_QUERY = `not all and (min-width: ${MOBILE_BREAKPOINT}px)`;

const subscribe = (onChange: () => void) => {
  const mobileMediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
  mobileMediaQueryList.addEventListener('change', onChange);

  return () => {
    mobileMediaQueryList.removeEventListener('change', onChange);
  };
};

const isMobileViewport = () => window.matchMedia(MOBILE_MEDIA_QUERY).matches;

// The server and hydration render desktop. A component mounted later reads the viewport on its first render, so a
// layout picked from it doesn't swap, and remount its children, right after it opens.
const useIsMobile = () => useSyncExternalStore(subscribe, isMobileViewport, () => false);

export default useIsMobile;
